
<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step5-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step5-desktop>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="screenWidth <= 768">
  <app-quote-step5-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step5-mobile>
</ng-container> -->